import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import YearPicker from "dashboards/lite/YearPicker";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';

export default function EmailDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["google_analytics", "total", "sessions"], props.table_data) ? Object.keys(jsDig(["google_analytics", "total", "sessions"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  // Read the 'year' query param if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const queryYear = parseInt(urlParams.get("year"), 10);

  // If queryYear is not a valid number, use the current year, else use queryYear
  const thisYear = isNaN(queryYear) ? new Date().getFullYear() : queryYear;
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/email.svg");
  mainIcon = <div className="other-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  const dashboardType = "email"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});

  return (
    <>
      <div className="lite-dashboard email-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>E-mail Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <YearPicker />
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"email"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
              <LiteExportPDF companyName={props.company_name} dashName="Email" />
            </div>
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "sessions", "data"], props.chart_data)}
                chartName="E-mail Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", revenueOrConversions, "data"], props.chart_data)}
                chartName={`${capitalize(revenueOrConversions)}`}
                metric={revenueOrConversions}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "conversion_rate", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "conversion_rate", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "conversion_rate", "data"], props.chart_data)}
                chartName="Conversion Rate L60D"
                metric="conversion_rate"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", revenueOrConversions]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["google_analytics", "total"], props.table_data)}
                tableName="Total E-mail Performance"
                dimensions={metricTableDimensions}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "email_list_growth", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "email_list_growth", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "email_list_growth", "data"], props.chart_data)}
                chartName="E-mail List Growth L90D"
                metric="email_list_growth"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["clicks", "ctr", "conversions", "conversion_rate", revenueOrConversions]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["email_platforms", "campaigns"], props.table_data)}
                tableName="Campaigns"
                skipPrev={true}
                dimensions={metricTableDimensions}
              />
            </div>
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["clicks", "ctr", "conversions", "conversion_rate", revenueOrConversions]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["email_platforms", "flows"], props.table_data)}
                tableName="Flows"
                skipPrev={true}
                dimensions={metricTableDimensions}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["clicks", "ctr", "open_rate", "conversions", "conversion_rate", revenueOrConversions]}
                subHeaderOrder={[""]}
                data={jsDig(["email_platforms", "recent_campaigns"], props.table_data)}
                tableName="Recent Campaigns"
                skipPrev={true}
                dimensions={props.campaign_dimensions}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", revenueOrConversions]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["google_analytics", "l60"], props.table_data)}
                tableName="Total E-mail Performance - Daily L60D"
                dimensions={jsDig(["google_analytics", "l60", "sessions"], props.table_data) ? Object.keys(jsDig(["google_analytics", "l60", "sessions"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["google_analytics", "l7"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
